<template>
    <div class="content1" style="font-size: 16px;" id="carteBlanche">
        <div style="padding-top: 1rem;max-height: 716px;overflow: auto;">
          <div class="function_class" v-if="entrustEdit">
            <div class="function_button" @click="addClick()">
              <img src="../../../image/emp1.png" width="19px">
              <div style="color: #ffa647;margin-left: 5px;">添加</div>
            </div>
            <div class="function_button" @click="deleteClick()">
              <img src="../../../image/shanchu.png"  width="19px">
              <div style="color: #ed4849;margin-left: 5px;">刪除</div>
            </div>
            <a-upload name="file" :data='{token:$store.state.token,account_number:items.account_number}' :headers='{token:$store.state.token}'
              class="avatar-uploader" :show-upload-list="false"
              :before-upload="beforeUpload" @change="handleChange" :action="$api.importEntrustInvestExcel" 
              style="display: block;">
              <div class="function_button">
                <img src="../../../image/endexs.png"  width="19px">
                <div style="color: rgb(88, 133, 234);margin-left: 5px;font-size: 16px;">導入</div>
              </div>
            </a-upload>
            <div class="function_button"  @click="upClick()">
              <img src="../../../image/xiazai.png"  width="19px">
              <div style="color: #3bc7a1;margin-left: 5px;">導出</div>
            </div>
          </div>
          <div style="margin-top: 1rem;height: 500px;overflow-y: auto">
            <a-table style="width:100%;" :columns="columns" :data-source="columnsData"  id='fromtable'
              :rowKey='(record, index) => index'
              :rowSelection="rowSelection"
              :bordered="true"
              :pagination="false"
            >

              <!-- 产品编号 -->
              <div slot="product_code" slot-scope="record">
                <div v-if="record.id">{{ record.product_code }}</div>
                <a-input v-else v-model="record.product_code"/>
              </div>
              <!-- 产品名称 -->
              <div slot="product_name" slot-scope="record">
                <div v-if="record.id">{{ record.product_name }}</div>
                <a-input v-else v-model="record.product_name"/>
              </div>
              <!-- 行业类别 -->
              <div slot="type" slot-scope="record">
                <div v-if="record.id">{{ record.type }}</div>
                <a-input v-else v-model="record.type"/>
              </div>
              <!-- 持有单位 -->
              <div slot="holding_unit" slot-scope="record">
                <a-input-number class="hide_arrows" :disabled="entrustAudit" v-model="record.holding_unit" @blur="countblur(record)" />
              </div>
              <!-- 平均价格 -->
              <div slot="average_price" slot-scope="record">
                <a-input-number class="hide_arrows" :disabled="entrustAudit" v-model="record.average_price" @blur="countblur(record)"/>
              </div>
              <!-- 收市价格 -->
              <div slot="closing_price" slot-scope="record">
                <a-input-number class="hide_arrows" :disabled="entrustAudit" v-model="record.closing_price" @blur="countblur(record)"/>
              </div>
              <!-- 收市价格 -->
              <div slot="market_value" slot-scope="record">
                <div><span>HKD </span> {{ record.market_value }}</div>
              </div>
              <!-- 操作 -->
              <div slot="operate" slot-scope="record">
                <img src="../../../image/buy.png" style="cursor: pointer;" @click="buyClick(record)">
              </div>
            </a-table>
          </div>
          <div class="sum_class" style="margin-top:0.5rem;">
            <div class="sum_class">
              <div>可用投資金額：</div> 
              <div> <span>HKD</span> {{ investmentAmount }}</div>
            </div>
            <div class="sum_class" style="margin-left: 30px;">
              <div>淨資產：</div> 
              <div> <span>HKD</span> {{ Number(netAsset).toFixed(2) }}</div>
            </div>
          </div>
          <div class="submit_class">
            <div class="submit_but" style="background: #0c828d;" v-if="entrustEdit" @click="addInvestment()">提交</div>
            <div class="submit_but" style="background: #0c828d;" v-if="entrustAudit&&columnsData.length>0" @click="auditInvestment('1')">審核通過</div>
            <div class="submit_but" style="background: #ed4849;" v-if="entrustAudit&&columnsData.length>0" @click="auditInvestment('2')">審核拒絕</div>
          </div>
        </div>
        <sellOut v-if="sellFlag" @child="sellClick" :items="buyList" :investmentAmount="investmentAmount"></sellOut>
        <exportData  v-if="upFlag" @child="upclose" ></exportData>
        <div :class="['pdfview',pdfShow ? 'pdfShow' : '']" @click="pdfShowUNEvent()">
          <div class="pdfviewIn">
            <div class="pdfTitle">
            <img @click.stop="printEvent()" src="../../../image/icon_dayin.png">
            </div>
            <iframe id="iframePdf1" :src="allurl" style="width: 100%; height: 100%" frameborder="0"></iframe>
            <iframe id="toPrintIframe2" style="display:none;" :src="pdfBolUrl" frameborder="0"></iframe>
          </div>
        </div>
  </div>
</template>

<script>
import sellOut from './sellOut.vue'
import exportData from "./exportData1";
import https from '@/plugins/http.js';
export default {
  props: ["items","father"],
  components:{sellOut,exportData},
  data() {
    return {
      entrustEdit: this.$store.state.rolesdata.indexOf('entrustEdit') >= 0, // 全权委托编辑
      entrustAudit: this.$store.state.rolesdata.indexOf('entrustAudit') >= 0, // 全权委托审核
      columnsData:[
        // {
        //   id:1,
        //   product_code:'01211.HK',
        //   product_name:'BYD COMPANY',
        //   type:'非必要性消费',
        //   holding_unit:'500',
        //   average_price:'297.00',
        //   closing_price:'179.00',
        //   market_value:'HKD 148,500.00',
        //   asset_ratio:'29.70%',
        //   audit_date:'2025/04/23',
        // }
      ],
      netAsset:'',
      investmentAmount:'',
      selectedRows:[],
      columns: [
        {
          title: '產品編號',
          dataIndex: '',
          align: 'center',
          width: '10%',
          scopedSlots: {
            customRender: 'product_code'
          }
        },
        {
          title: '產品名稱',
          dataIndex: '',
          align: 'left',
          width: '13%',
          scopedSlots: {
            customRender: 'product_name'
          }
        },				
        {
          title: '行業類別',
          dataIndex: '',
          align: 'center',
          width: '13%',
          scopedSlots: {
            customRender: 'type'
          }
        },	
        {
          title: '持有數量',
          dataIndex: '',
          align: 'center',
          width: '7%',
          scopedSlots: {
            customRender: 'holding_unit'
          }
        },
        {
          title: '平均價格',
          dataIndex: '',
          align: 'center',
          width: '7%',
          scopedSlots: {
            customRender: 'average_price'
          }
        },
        {
          title: '收市價格',
          dataIndex: '',
          align: 'center',
          width: '7%',
          scopedSlots: {
            customRender: 'closing_price'
          }
        
        },
        {
          title: '市場價值',
          dataIndex: '',
          align: 'center',
          width: '14%',
          scopedSlots: {
            customRender: 'market_value'
          }
        },
        {
          title: '資產比例',
          dataIndex: 'asset_ratio',
          align: 'center',
          width: '10%',
        },
        {
          title: '買入時間',
          dataIndex: 'audit_date',
          align: 'center',
          width: '13%',
        },
        {
          title: '操作',
          dataIndex: '',
          align: 'center',
          width: '7%',
          scopedSlots: {
            customRender: 'operate'
          }
        },
      ],
      khtypeArr:[
        '非必要性消費',
        '咨詢科技',
        '金融類',
        '能源類',
        '其他',
      ],
      sellFlag:false,
      buyList:{},
      upFlag:false,
      pdfShow:false,
      blob:'',
      allurl: '',
      pdfBolUrl: '',
    };
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRows,
        onChange: this.onSelectChange,
        // 可以添加其他配置
        getCheckboxProps: record => ({
          // 可以设置禁用等属性
          props: {
            disabled:record.audit_schedule==0 
          }
        })
      }
    }
  },
  mounted() {
    console.log(this.items, "彈窗");
    this.getInvestment()
  },

  methods: {
    // 监听输入值并计算
    countblur(val){
      if (val.holding_unit && val.average_price && val.closing_price) {
        // 最新回報=“收市價格” – “平均價格”
        // 回報比率=”最新回報” / “平均價格”
        // 市場價值=“收市價格” x “持有單位”
        // 資產比例=(”市場價值” / “淨資產”) x100%
        // “淨資產”=總合所有產品的” 市場價值”
        val.market_value = (val.closing_price*val.holding_unit).toFixed(2)
        this.netAsset = 0
        for (let i = 0; i < this.columnsData.length; i++) {
          const num = this.columnsData[i];
          this.netAsset += Number(num.market_value)
        }
        for (let i = 0; i < this.columnsData.length; i++) {
          const num1 = this.columnsData[i];
          num1.asset_ratio = ((num1.market_value/this.netAsset)*100).toFixed(2) + '%'
        }

      }

    },
    // 買入賣出彈窗
    buyClick(val){
      if (val.id) {
        this.buyList = val
        this.sellFlag = true
      }
    },
    // 賣出彈窗回調
    sellClick(){
      this.sellFlag = false
      this.getInvestment()
    },
    // 添加
    addClick(){
      this.columnsData.unshift(
        {
          id:null,
          product_code:'',
          product_name :'',
          type:'',
          holding_unit:'',
          average_price:'',
          closing_price:'',
          market_value:'',
          asset_ratio:'',
          audit_date:'',
        }
      )
    },
    // 刪除
    deleteClick(){
      if (this.selectedRows.length<=0) {
        return
      }
      this.$confirm("是否刪除此數據，刪除後不可恢復", "是否刪除？", {
        confirmButtonText: "確認",
        cancelButtonText: "取消",
        confirmButtonClass: "confirmbtn",//自定义class
        type: "warning"
      }).then(() => {
        console.log(this.selectedRows);
        var delList = this.selectedRows.map(index => this.columnsData[index]);
        var delList1 = delList.filter(item => item.id !== null).map(item => item.id);
        // var delList2 = delList.filter(item => item.id == null);
        console.log(delList1);
        if (this.selectedRows.length>0) {
          for (let i = 0; i < this.selectedRows.length; i++) {
            this.columnsData.splice(this.selectedRows[i]-i, 1);
          }
        }
        if (delList1.length>0) {
          this.$ajax({
            method: "post",
            url: this.$api.removeInvestmentByIds,
            data: delList1,
          }).then((res) => {
            if (res.data.qmiscode == 1000) {
              this.selectedRows = []
              this.getInvestment()
            } else {
            }
          });
        }else{
          this.selectedRows = []
        }
      }).catch(() => {
      })

    },
    //导入按钮方法
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        // this.$confirm("只能上傳列表中沒有的新數據", "提示", {
        //     confirmButtonText: "確認",
        //     cancelButtonText: "取消",
        //     confirmButtonClass: "confirmbtn",//自定义class
        //     type: "warning"
        //   }).then(() => {
            var fileFormat = file.name
              .substring(file.name.lastIndexOf("."))
              .toLowerCase();
            const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
            if (!isJpgOrPng) {
              this.$message.error('只能上傳xls或xlsx文件!');
            }else{
              resolve(file);
            }
            return isJpgOrPng;
      //     }).catch(() => {

      //     })
      });
    },
    //导入按钮
    handleChange(info) {
      if (info.file.response) {
        if (info.file.response.qmiscode == 1000) {
          // this.loading = true;
          this.$message.success('導入成功');
          this.getInvestment();
        } else {
          // this.loading = false;
          this.$message.error(info.file.response.qmismsg);
        }
    }else{
      App.oTool.warningT('暫無權限');
    }
    },
    // 导出
    upClick(){
      this.upFlag = true
    },
    // 导出回调
    upclose(val){
      this.upFlag = false;
      if (val.xzgs == 'PDF') {
        this.handopen(val.pxfs)
      }
      if (val.xzgs == 'Excel') {
        this.queryData(val.pxfs)
      }
    },
    //PDF导出按钮
    handopen(pxfs) {
      let str = this.$api.pdfs; //getUnsk
      let sort =  pxfs == undefined ? '' : pxfs
      let url = this.$api.exportEntrustInvestPDF;
      url += '?token=' + this.$store.state.token 
      url += '&account_number=' + this.items.account_number
      // url += '&beginTime=' + this.params.begin_time
      // url += '&endTime=' + this.params.end_time
      url += '&sort=' + sort
      this.allurl = str + url
      let _this = this;
      _this.pdfUrl = url
      https.fetchGetPdf(_this.pdfUrl).then((data) => {
        let blob = new Blob([data], {
          type: 'application/pdf'
        });
        _this.blob = blob;
        let b = window.URL.createObjectURL(blob);
        _this.pdfBolUrl = b;
      }).catch(err => {
        console.log(err);
      });
      //
      setTimeout(() => {
        this.pdfShow = true;
      }, 500);
    },
    pdfShowUNEvent() {
      this.pdfShow = false;
    },
    printEvent() {
      let _this = this; //toPrintIframe2
      const printIframe = document.getElementById("toPrintIframe2");
      let frameWindow = printIframe.contentWindow;
      console.log(frameWindow)
      console.log(_this.blob)
      frameWindow.print();
      setTimeout(() => {
        window.URL.revokeObjectURL(_this.pdfBolUrl);
      }, 500)
    },
    // 表格导出下载
    queryData(val){
      let url = ''
      let _this = this;
      let sort =  val == undefined ? "" : val
      url = _this.$api.exportEntrustInvestExcel;
      url += '?token=' + _this.$store.state.token
      url += '&account_number=' + this.items.account_number
      // url += '&beginTime=' + this.params.begin_time
      // url += '&endTime=' + this.params.end_time
      url += '&sort=' + sort
      window.location.href = url;
    },
    // 列表復選框
    onSelectChange(selectedRowKeys) {
      this.selectedRows = selectedRowKeys;
    },
    handleCancel(ev) {
      this.$emit("child", 0);
    },
    // 提交接口
    addInvestment(ev) {
      this.$ajax({
        method: "post",
        url: this.$api.addInvestment,
        data: {
          account_number:this.items.account_number,
          entrustList:this.columnsData
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.$message.success(res.data.qmismsg);
          // this.getInvestment()
          this.father.handleCancel()
        } else {
          this.$message.error(res.data.qmismsg);
        }
      });
    },
    // 審核接口
    auditInvestment(val) {
      this.$ajax({
        method: "post",
        url: this.$api.auditInvestment,
        data: {
          account_number:this.items.account_number,
          audit_flag:val
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.$message.success(res.data.qmismsg);
          // this.getInvestment()
          this.father.handleCancel()
        } else {
          this.$message.error(res.data.qmismsg);
        }
      });
    },
    getInvestment(ev) {
      this.$ajax({
        method: "post",
        url: this.$api.getInvestment,
        data: {
          account_number:this.items.account_number,
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.columnsData = res.data.entrustList;
          this.netAsset = res.data.netAsset;
          this.investmentAmount = res.data.investmentAmount;
        } else {
          this.$message.error(res.data.qmismsg);
        }
      });
    },

  },
};
</script>

<style>
 #carteBlanche .ant-upload.ant-upload-select{
    display: block !important;
  }

</style>
<style lang="scss" scoped>
  @import "../carteBlanche.css";
  #carteBlanche {
		.pdfview {
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0vw;
			top: 0vh;
			background-color: rgba(0, 0, 0, 0.7);
			z-index: 99;
			display: none;
		}

		.pdfShow {
			display: block;
		}

		.pdfview .pdfviewIn {
			position: fixed;
			width: 80vw;
			height: 80vh;
			left: calc(50% - 40vw);
			top: 5vh;
		}

		.pdfview .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}

		.pdfview .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}
	}
  .submit_class{
    display: flex;
    align-items: center;
    justify-content:end;
    padding: 2rem 0;
  }
  .submit_but{
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 5rem;
    height: 2rem;
    font-size: 0.8rem;
    color: #fff;
    border: 0;
    border-radius: 5px;
    margin-left: 1.5rem;
  }
  .sum_class{
    display: flex;
    align-items: center;
  }
  .function_class{
    display: flex;
    align-items: center;
  }
  .function_button{
    display: flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
  }


.show-more{
  text-align: center;
  padding-bottom: 15px;
}
.score-img {
  width: 16px;
  transition: all 0.3s;
}
.rotate-img {
  transform: rotate(180deg);
}
.content-top{
  width: 100%;
  height: 60px;
  background:#fafafa; 
  color: #0c8b97;
  line-height: 60px;
  padding: 0 20px;
  font-weight: 600;

}
.content-top1{
  width: 100%;
  height: 60px;
  background:#ffffff; 
  color: #000000;
  line-height: 60px;
  display: flex;
  padding: 0 20px;

}
.content-top2{
  width: 100%;
  background:#ffffff; 
  color: #000000;
  // line-height: 60px;
  padding: 0 20px;

}
.phoneSty .ant-select-arrow {
  right: 6px !important;
}
.phoneSty .ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 35%;
}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix {
  left: 2px !important;
  top: 18px;

}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 25.5px !important;
}
.phoneSty .ant-select-selection {
  border: 0 !important;
  height: 25px;
}
.phoneSty .ant-select-focused .ant-select-selection,
.ant-select-selection:active,
.ant-select-selection:focus {
  border: 0 !important;
  box-shadow: none !important;
}


.address .ant-form-item-label {
  width: 15% !important;
}
.address .ant-form-item-control-wrapper {
  width: 85% !important;
}
.content1{
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  padding: 1rem;
  background-color: #fff;
  width: 65rem !important;
  margin: 0 auto;
  margin-bottom: 1rem;
  min-height: 50px;
}
#warp_sim12 .ant-modal-header,
#warp_sim12 .ant-modal-body {
  background-color: #e5e5e5 !important;
  padding: 1rem;
  padding-top: 0.7rem;
}

.mark-file {
  position: absolute;
  top: 0;
  left: 0;

  div {
    width: 6rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    display: inline-block;
  }
}

#warp_sim12 {
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }
  .ant-form-explain {
    display: none;
  }

  .ant-modal {
    top: 8%;
  }

  .ant-col-12 {
    text-align: right;
  }
  .myleft {
    text-align: left;
  }
  .ant-form-item-label {
    width: 30%;
  }

  .ant-form-item,
  .ant-form-item-control {
    width: 100%;

    .ant-calendar-picker {
      width: 100%;
    }
  }

  .ant-radio-group-default {
    width: 100%;
    margin-top: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 0.8rem;
    }
  }

  .ant-form-item-control-wrapper {
    width: 70%;

    .ant-form-item-control {
      width: 100%;
    }
  }

  #lastname {
    text-align: right;

    .ant-form-item-label {
      width: 10%;
    }

    .ant-form-item-control-wrapper {
      width: 86%;
    }
  }

  .ant-form-inline .ant-form-item {
    margin-right: 0;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-form-item {
    margin-bottom: 1rem;
  }

  .ant-form-item label {
    font-size: 0.8rem !important;
  }

  .ant-input {
    font-size: 0.8rem !important;
  }

  .ant-select-selection-selected-value {
    font-size: 0.8rem !important;
  }

  .ant-form-item-children {
    font-size: 0.8rem !important;
  }

  .ant-modal-body {
    padding: 0;
    padding-top: 2.5rem;
    font-size: 0.8rem;
  }

  .btn1 {
    cursor: pointer;
    width: 8rem;
    height: 2rem;
    font-size: 0.8rem;
    color: #fff;
    border: 0;
    border-radius: 5px;
    margin: 0 3rem;
  }

  .btnx {
    background-color: #0c8b97;
  }

  .btn2 {
    background-color: #ed4849;
  }

  .mydivs {
    max-height: 7rem;
    overflow-y: auto;
    // margin-bottom: 1rem;
    padding: 1rem;
    margin-left: 4%;
    width: 96%;
    background-color: #f5f5f5;
    margin-bottom: 1rem;

    .c {
      font-size: 0.8rem;
    }

    .f {
      // text-align: right;
      display: flex;
      justify-content: space-between;
    }

    .t {
      margin: 0.5rem 0;
      border-bottom: 1px solid #d9d9d9;
    }
  }
}
</style>
